import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "batchSystem__tag" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "usageRule__direction" }, "每辆车只有一个制度，分配新制度时会替换车辆原有的制度", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: _ctx.visible,
    "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.visible) = $event)),
    class: "projectApplyBlance",
    width: "480px",
    title: "批量设置制度",
    "confirm-loading": _ctx.submiting,
    onOk: _ctx.onSubmit,
    onCancel: _ctx.closeModal
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_form, {
        ref: "editorFormRef",
        model: _ctx.formData,
        rules: _ctx.rules,
        "label-col": { span: 6 },
        "wrapper-col": { span: 14 },
        style: {"width":"100%"}
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createTextVNode(" 请选择制度 "),
              _createElementVNode("span", null, [
                _createTextVNode("已选："),
                _createElementVNode("b", null, _toDisplayString(_ctx.selectedStaff.length) + "辆", 1)
              ])
            ])
          ]),
          _createVNode(_component_a_form_item, { name: "restrictId" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_select, {
                value: _ctx.formData.restrictId,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.restrictId) = $event)),
                placeholder: "请选择车辆制度",
                "show-search": "",
                "filter-option": _ctx.filterOption,
                style: {"width":"100%"}
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.systemList, (item) => {
                    return (_openBlock(), _createBlock(_component_a_select_option, {
                      key: item.id,
                      value: item.id
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.title), 1)
                      ]),
                      _: 2
                    }, 1032, ["value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["value", "filter-option"])
            ]),
            _: 1
          }),
          _hoisted_3
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    _: 1
  }, 8, ["visible", "confirm-loading", "onOk", "onCancel"]))
}